import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsSummaryDetailsTabPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabPanel/LearnpathsSummaryDetailsTabPanel'
import LearnpathsSummaryDetailsTabsProgressUserGroups from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabsProgressUserGroups/LearnpathsSummaryDetailsTabsProgressUserGroups'

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/progress-user-groups',
)({
  component: ProgressUserGroupsTab,
})

function ProgressUserGroupsTab() {
  return (
    <LearnpathsSummaryDetailsTabPanel>
      <LearnpathsSummaryDetailsTabsProgressUserGroups />
    </LearnpathsSummaryDetailsTabPanel>
  )
}
